import React from "react";

import { SkipInt, TakeInt } from "@every.org/common/src/routes/index";
import { getTagSupportersRouteSpec } from "@every.org/common/src/routes/tag";

import { SupportersList, SupportersListProps } from "./";

import { queryApi } from "src/utility/apiClient";

interface NonprofitTagSupportersProps
  extends Omit<SupportersListProps, "fetchQuery"> {
  nonprofitTag: string;
}

export const NonprofitTagSupporters: React.FCC<NonprofitTagSupportersProps> = ({
  nonprofitTag,
  ...rest
}) => {
  const fetchQuery = (take: TakeInt, skip: SkipInt) => {
    return queryApi(getTagSupportersRouteSpec, {
      routeTokens: { tagName: nonprofitTag },
      body: {},
      queryParams: { take, skip },
    });
  };

  return <SupportersList fetchQuery={fetchQuery} {...rest} />;
};
